/**
 * Badge Event Router — maps app events to the subset of badges that could trigger.
 * Reduces per-event badge checks from 18 to ~5-9.
 */

export type BadgeEvent =
  | 'expense_logged'
  | 'streak_updated'
  | 'profile_saved'
  | 'motivation_style_changed'
  | 'template_saved'
  | 'calm_mode_toggled'
  | 'summary_viewed'
  | 'badges_page_opened'
  | 'referral_completed';

export const BADGE_EVENT_MAP: Record<BadgeEvent, string[]> = {
  expense_logged: [
    'first_expense', 'coffee_lover', 'pattern_spotter',
    'subscription_hunter', 'budget_finisher', 'traveller',
    'xp_collector', 'still_here', 'again',
  ],
  streak_updated: [
    'seven_days', 'thirty_days', 'ninety_days', 'longest_streak',
    'still_here', 'again',
  ],
  profile_saved: ['named'],
  motivation_style_changed: ['found_your_style'],
  template_saved: ['template_maker'],
  calm_mode_toggled: ['calm_achiever'],
  summary_viewed: ['the_long_view'],
  badges_page_opened: ['calm_achiever', 'the_long_view', 'budget_finisher'],
  referral_completed: ['connector'],
};
